import React from 'react'
import ReactDOM from 'react-dom/client'
import { initFirebaseAuth } from './firebase'
import router from './router'
import './index.css'

async function bootstrap() {
  // Skip Firebase in development, unless explicitly testing the real
  // Google Sign-In flow locally (pair with server's FORCE_FIREBASE_AUTH —
  // see server/src/routes/admin.ts).
  const forceFirebase = import.meta.env.VITE_FORCE_FIREBASE === 'true'
  if (import.meta.env.DEV && !forceFirebase) {
    console.log('ℹ️ Firebase auth bypassed in development mode')
  } else {
    const configResponse = await fetch('/api/firebase-config')
    if (!configResponse.ok) {
      throw new Error('Failed to load Firebase config')
    }
    const firebaseConfig = await configResponse.json()
    initFirebaseAuth(firebaseConfig)
  }

  // Mount React app
  const root = document.getElementById('root')
  if (!root) {
    throw new Error('Root element not found')
  }

  ReactDOM.createRoot(root).render(
    <React.StrictMode>
      {router}
    </React.StrictMode>
  )
}

bootstrap().catch(console.error)
